"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = portalStatus;

var _actionTypes = require("EmailData/actions/actionTypes");

var _portalSuspension = require("EmailData/constants/portalSuspension");

var _PortalDismissStatus = _interopRequireDefault(require("EmailData/models/PortalDismissStatus"));

var _PortalStatus = _interopRequireDefault(require("EmailData/models/PortalStatus"));

var initialState = _PortalStatus.default.from({});

function portalStatus() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actionTypes.REQUEST_PORTAL_STATUS:
      return state.mergeDeep({
        loading: true
      });

    case _actionTypes.RECEIVE_PORTAL_STATUS:
      if (action.error !== true) {
        return state.mergeDeep(_PortalStatus.default.from(action.payload));
      }

      return state;

    case _actionTypes.REQUEST_PORTAL_DISMISS_STATUS:
      return state.mergeDeep({
        dismissStatus: _PortalDismissStatus.default.from({
          loading: true
        })
      });

    case _actionTypes.RECEIVE_PORTAL_DISMISS_STATUS:
    case _actionTypes.RECEIVE_UPDATE_PORTAL_DISMISS_STATUS:
      if (action.error !== true) {
        return state.mergeDeep({
          dismissStatus: _PortalDismissStatus.default.from(action.payload)
        });
      }

      return state;

    case _actionTypes.RECEIVE_SUSPENSION_APPEAL:
      if (action.error !== true) {
        var appealId = action.payload && action.payload.appealReference ? action.payload.appealReference : null;
        return state.mergeDeep({
          precogHealthStatus: {
            appealId: appealId,
            appealState: _portalSuspension.SUSPENSION_APPEAL_STATUS.PENDING
          }
        });
      }

      return state.mergeDeep({
        precogHealthStatus: {
          appealState: _portalSuspension.SUSPENSION_APPEAL_STATUS.ERROR
        }
      });

    default:
      return state;
  }
}

module.exports = exports.default;